import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 4l3 3l-3 3","key":"svg-0"}],["path",{"d":"M18 20l3 -3l-3 -3","key":"svg-1"}],["path",{"d":"M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5","key":"svg-2"}],["path",{"d":"M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5","key":"svg-3"}]]

const IconArrowsShuffle2 = createReactComponent('outline', 'arrows-shuffle-2', 'ArrowsShuffle2', __iconNode);

export default IconArrowsShuffle2;